import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getSingleValueAnswer,
	renderQuestionAnswer,
	renderQuestionAnswerType2,
	renderType1TableAnswer,
	renderType3TableAnswer
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRSectionA = ({
	t,
	page1,
	page1PrevData,
	yearFilter
}) => {

	// Wrapper functions to maintain compatibility with existing calls that pass page parameter
	const getSingleValueAnswerWrapper = (page, index) => {
		if (page === 1) {
			return getSingleValueAnswer(page1, index);
		}
		return <></>;
	};

	const renderTableAnswerWrapper = (page, qIndex, colNos) => {
		if (page === 1) {
			const block = page1[QUES_CODE_PREFIX + qIndex];
			if (block?.keyValueType === 'TYPE_3_TABLE') {
				const type3 = renderType3TableAnswer(page1, qIndex, colNos);
				if (type3 != null) return type3;
			}
			return renderType1TableAnswer(page1, qIndex, colNos);
		}
		return <tr></tr>;
	};

	const renderA1 = () => {
		return (
			<section className="mb-4">
				<div className="ETA_card_Section_sub_head mb-3">
					<b>I. Details of the listed entity</b>
				</div>
				<div className="ETA_card_Section_sub_body">
					<Table bordered >
						<tbody>
							<tr>
								<th scope="row">1.</th>
								<th>Corporate Identity Number (CIN) of the Listed Entity</th>
								<td>{getSingleValueAnswerWrapper(1, 1)}</td>
							</tr>
							<tr>
								<th scope="row">2.</th>
								<th>Name of the Listed Entity</th>
								<td>{getSingleValueAnswerWrapper(1, 2)}</td>
							</tr>
							<tr>
								<th scope="row">3.</th>
								<th>Year of incorporation</th>
								<td className="brsr-export-keep-left">{getSingleValueAnswerWrapper(1, 3)}</td>
							</tr>
							<tr>
								<th scope="row">4.</th>
								<th>Registered office address</th>
								<td>{getSingleValueAnswerWrapper(1, 4)}</td>
							</tr>
							<tr>
								<th scope="row">5.</th>
								<th>Corporate address</th>
								<td>{getSingleValueAnswerWrapper(1, 5)}</td>
							</tr>
							<tr>
								<th scope="row">6.</th>
								<th>E-mail</th>
								<td>{getSingleValueAnswerWrapper(1, 6)}</td>
							</tr>
							<tr>
								<th scope="row">7.</th>
								<th>Telephone</th>
								<td>{getSingleValueAnswerWrapper(1, 7)}</td>
							</tr>
							<tr>
								<th scope="row">8.</th>
								<th>Website</th>
								<td>{getSingleValueAnswerWrapper(1, 8)}</td>
							</tr>
							<tr>
								<th scope="row">9.</th>
								<th>Financial year for which reporting is being done</th>
								<td>{getSingleValueAnswerWrapper(1, 9)}</td>
							</tr>
							<tr>
								<th scope="row">10.</th>
								<th>Name of the Stock Exchange(s) where shares are listed</th>
								<td>{getSingleValueAnswerWrapper(1, 10)}</td>
							</tr>
							<tr>
								<th scope="row">11.</th>
								<th>Paid-up Capital</th>
								<td className="brsr-export-keep-left">{getSingleValueAnswerWrapper(1, 11)}</td>
							</tr>
							<tr>
								<th scope="row">12.</th>
								<th>Name and contact details (telephone, email address) of the person who may be contacted in case of any queries on the BRSR report</th>
								<td>{getSingleValueAnswerWrapper(1, 12)}</td>
							</tr>
							<tr>
								<th scope="row">13.</th>
								<th>Reporting boundary - Are the disclosures under this report made on a standalone basis (i.e. only for the entity) or on a consolidated basis (i.e. for the entity and all the entities which form a part of its consolidated financial statements, taken together).</th>
								<td>{getSingleValueAnswerWrapper(1, 13)}</td>
							</tr>
							<tr>
								<th scope="row">14.</th>
								<th>Name of assurance provider</th>
								<td>{getSingleValueAnswerWrapper(1, 14)}</td>
							</tr>
							<tr>
								<th scope="row">15.</th>
								<th>Type of assurance obtained</th>
								<td>{getSingleValueAnswerWrapper(1, 15)}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</section>
		);
	};

	const renderA2 = () => {
		return (
			<section className="mb-4">
				<div className="ETA_card_Section_sub_head mb-3">
					<b>II.Products/services </b>
				</div>
				<div className="ETA_card_Section_sub_body">
					<div className="brsr-list">
						<div className='brsr-list-item'>
							<b>16. Details of business activities (accounting for 90% of the turnover):</b>
							<div className="mt-2">
								<Table bordered size="sm">
									<thead>
										<tr>
											<th className='white-space'>S. No.</th>
											<th>Description of Main Activity </th>
											<th>Description	of Business Activity </th>
											<th>% of Turnover of the entity</th>
										</tr>
									</thead>
									<tbody>
										{renderTableAnswerWrapper(1, 16, ['', 'a', 'b', 'c'])}
									</tbody>
								</Table>
							</div>
						</div>
						<div className='brsr-list-item'>
							<b>17. Products/Services sold by the entity (accounting for 90% of the entity's Turnover):</b>
							<div className="mt-2">
								<Table bordered size="sm">
									<thead>
										<tr>
											<th className='white-space'>S. No.</th>
											<th>Product/Service  </th>
											<th>NIC Code  </th>
											<th>% of total Turnover contributed </th>
										</tr>
									</thead>
									<tbody>
										{renderTableAnswerWrapper(1, 17, ['', 'a', 'b', 'c'])}
									</tbody>
								</Table>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	};

	const renderA3Q18 = () => {
		const answer = {};
		page1[QUES_CODE_PREFIX + '18']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		return (
			<section className="mb-4">
				<div className="ETA_card_Section_sub_head mb-3">
					<b>III. Operations  </b>
				</div>
				<div className="ETA_card_Section_sub_body">
					<div className='brsr-list'>
						<div className='brsr-list-item'>
							<b>18. Number of locations where plants and/or operations/offices of the entity are situated:</b>
							<div className="mt-2">
								<Table bordered size="sm">
									<thead>
										<tr>
											<th>Location </th>
											<th>Number of plants  </th>
											<th>Number of offices </th>
											<th>Total </th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th>National </th>
											<td>{answer[QUES_CODE_PREFIX + '18aa'] ?? ''}</td>
											<td>{answer[QUES_CODE_PREFIX + '18ab'] ?? ''}</td>
											<td>{answer[QUES_CODE_PREFIX + '18ac'] ?? ''}</td>
										</tr>
										<tr>
											<th>International </th>
											<td>{answer[QUES_CODE_PREFIX + '18ba'] ?? ''}</td>
											<td>{answer[QUES_CODE_PREFIX + '18bb'] ?? ''}</td>
											<td>{answer[QUES_CODE_PREFIX + '18bc'] ?? ''}</td>
										</tr>
									</tbody>
								</Table>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	};

	const renderA3Q19 = () => {
		const answer = {};
		page1[QUES_CODE_PREFIX + '19']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		return (
			<div className='brsr-list-item'>
				<b>19. Markets served by the entity:</b>
				<div className='brsr-sublist'>
					<div className='brsr-list-item'>
						<b>a. Number of locations</b>
						<div className="mt-2">
							<Table bordered size="sm">
								<thead>
									<tr>
										<th>Locations </th>
										<th>Number  </th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>National (No. of States) </td>
										<td>{answer[QUES_CODE_PREFIX + '19aa'] ?? ''}</td>
									</tr>
									<tr>
										<td>International (No. of Countries) </td>
										<td>{answer[QUES_CODE_PREFIX + '19ab'] ?? ''}</td>
									</tr>
								</tbody>
							</Table>
						</div>
					</div>
					{renderQuestionAnswer(
						'b. What is the contribution of exports as a percentage of the total turnover of the entity?',
						answer[QUES_CODE_PREFIX + '19b'] ?? ''
					)}
					{renderQuestionAnswer(
						'c. A brief on types of customers',
						answer[QUES_CODE_PREFIX + '19c'] ?? ''
					)}
				</div>
			</div>
		);
	};

	const renderA4Q20 = () => {
		const answer = {};
		page1[QUES_CODE_PREFIX + '20']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		return (
			<div className="ETA_card_Section_sub_body" >
				<div className='brsr-list'>
					<div className='brsr-list-item'>
						<b>20. Details as at the end of Financial Year:</b>
						<div className='brsr-sublist'>
							<div className='brsr-list-item'>
								<b>a. Employees and workers (including differently abled):</b>
								<div className="mt-2">
									<Table bordered size="sm">
										<thead>
											<tr>
												<th rowSpan="2" className='white-space'>S. No. </th>
												<th rowSpan="2">Particulars   </th>
												<th rowSpan="2">Total (A)   </th>
												<th colSpan="2" className="text-center">Male    </th>
												<th colSpan="2" className="text-center">Female </th>
											</tr>
											<tr>
												<th>No. (B) </th>
												<th>% (B/A)    </th>
												<th>No. (C)    </th>
												<th>% (C/A)     </th>
											</tr>
											<tr>
												<th colSpan={7} className="text-center font-color">EMPLOYEES </th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1. </td>
												<td>Permanent (D)</td>
												<td >{answer[QUES_CODE_PREFIX + '20a1a'] ?? ''}</td>
												<td >{answer[QUES_CODE_PREFIX + '20a1b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a1c'] ?? ''}</td>
												<td >{answer[QUES_CODE_PREFIX + '20a1d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a1e'] ?? ''}</td>
											</tr>
											<tr>
												<td>2. </td>
												<td>Other than Permanent (E)</td>
												<td>{answer[QUES_CODE_PREFIX + '20a2a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a2b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a2c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a2d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a2e'] ?? ''}</td>
											</tr>
											<tr>
												<td>3.</td>
												<td>
													<strong>Total employees (D + E) </strong>
												</td>
												<td>{answer[QUES_CODE_PREFIX + '20a3a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a3b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a3c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a3d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a3e'] ?? ''}</td>
											</tr>
											<tr>
												<td colSpan={7} className="text-center font-color">  <strong>WORKERS </strong> </td>
											</tr>
											<tr>
												<td>1.</td>
												<td>  Permanent (F) </td>
												<td>{answer[QUES_CODE_PREFIX + '20a4a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a4b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a4c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a4d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a4e'] ?? ''}</td>
											</tr>
											<tr>
												<td>2.</td>
												<td>  Other	than Permanent (G)  </td>
												<td>{answer[QUES_CODE_PREFIX + '20a5a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a5b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a5c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a5d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a5e'] ?? ''}</td>
											</tr>
											<tr>
												<td>3.</td>
												<td>
													<strong>Total employees (F + G) </strong>
												</td>
												<td>{answer[QUES_CODE_PREFIX + '20a6a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a6b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a6c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a6d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20a6e'] ?? ''}</td>
											</tr>
										</tbody>
									</Table>
								</div>
							</div>
							<div className='brsr-list-item'>
								<b>b. Differently abled employees and workers:</b>
								<div className="mt-2">
									<Table bordered size="sm">
										<thead>
											<tr>
												<th rowSpan="2" className='white-space'>S. No. </th>
												<th rowSpan="2">Particulars   </th>
												<th rowSpan="2">Total (A)   </th>
												<th colSpan={2} className="text-center">Male    </th>
												<th colSpan={2} className="text-center">Female </th>
											</tr>
											<tr>
												<th>No. (B) </th>
												<th>% (B/A)    </th>
												<th>No. (C)    </th>
												<th>% (C/A)     </th>
											</tr>
											<tr>
												<th colSpan={7} className="text-center font-color">DIFFERENTLY ABLED EMPLOYEES  </th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1. </td>
												<td>Permanent (D)</td>
												<td>{answer[QUES_CODE_PREFIX + '20b1a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b1b'] ?? ''} </td>
												<td>{answer[QUES_CODE_PREFIX + '20b1c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b1d'] ?? ''} </td>
												<td>{answer[QUES_CODE_PREFIX + '20b1e'] ?? ''}</td>
											</tr>
											<tr>
												<td>2. </td>
												<td>Other than Permanent (E)</td>
												<td>{answer[QUES_CODE_PREFIX + '20b2a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b2b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b2c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b2d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b2e'] ?? ''}</td>
											</tr>
											<tr>
												<td>3.</td>
												<td>
													<strong>Total	differently abled employees (D + E) </strong>
												</td>
												<td>{answer[QUES_CODE_PREFIX + '20b3a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b3b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b3c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b3d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b3e'] ?? ''}</td>
											</tr>
											<tr>
												<td colSpan={7} className="text-center font-color">  <strong>DIFFERENTLY ABLED WORKERS </strong> </td>
											</tr>
											<tr>
												<td>1.</td>
												<td>  Permanent (F) </td>
												<td>{answer[QUES_CODE_PREFIX + '20b4a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b4b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b4c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b4d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b4e'] ?? ''}</td>
											</tr>
											<tr>
												<td>2.</td>
												<td>  Other	than Permanent (G)  </td>
												<td>{answer[QUES_CODE_PREFIX + '20b5a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b5b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b5c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b5d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b5e'] ?? ''}</td>
											</tr>
											<tr>
												<td>3.</td>
												<td>
													<strong>Total differently abled workers (F + G)  </strong>
												</td>
												<td>{answer[QUES_CODE_PREFIX + '20b6a'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b6b'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b6c'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b6d'] ?? ''}</td>
												<td>{answer[QUES_CODE_PREFIX + '20b6e'] ?? ''}</td>
											</tr>
										</tbody>
									</Table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const renderA4Q21 = () => {
		const answer = {};
		page1[QUES_CODE_PREFIX + '21']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		return (
			<div className='brsr-list-item'>
				<b>21. Participation/Inclusion/Representation of women</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan="2"></th>
								<th rowSpan="2">Total (A)   </th>
								<th colSpan="2">No. and percentage of Females   </th>
							</tr>
							<tr>
								<th>No. (B)</th>
								<th>% (B/A) </th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Board of Directors </td>
								<td>{answer[QUES_CODE_PREFIX + '21-1a'] ?? ''}</td>
								<td>{answer[QUES_CODE_PREFIX + '21-1b'] ?? ''}</td>
								<td >{answer[QUES_CODE_PREFIX + '21-1c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Key	Management Personnel </td>
								<td>{answer[QUES_CODE_PREFIX + '21-2a'] ?? ''}</td>
								<td>{answer[QUES_CODE_PREFIX + '21-2b'] ?? ''}</td>
								<td >{answer[QUES_CODE_PREFIX + '21-2c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderA4Q22 = () => {
		const answer = {};
		page1[QUES_CODE_PREFIX + '22']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});

		const oneBack = {}, twoBack = {};
		if (page1PrevData['oneBack']) {
			page1PrevData['oneBack'][QUES_CODE_PREFIX + '22']?.keyValues?.forEach(val => {
				oneBack[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page1PrevData['twoBack']) {
			page1PrevData['twoBack'][QUES_CODE_PREFIX + '22']?.keyValues?.forEach(val => {
				twoBack[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>22. Turnover rate for permanent employees and workers</b>
				<div><i>(Disclose trends for the past 3 years) </i></div>

				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan="2"></th>
								<th colSpan="3" className="text-center FY_class white-nowrap">FY ({yearFilter})   </th>
								<th colSpan="3" className="text-center white-nowrap">FY ({yearFilter - 1})   </th>
								<th colSpan="3" className="text-center white-nowrap">FY ({yearFilter - 2}) </th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Male </th>
								<th className='FY_class_sub'>Female  </th>
								<th className='FY_class_sub'>Total </th>
								<th>Male </th>

								<th>Female  </th>
								<th>Total </th>
								<th>Male </th>
								<th>Female  </th>
								<th>Total </th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th>Permanent Employee</th>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '22-1a'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '22-1b'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '22-1c'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '22-1a'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '22-1b'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '22-1c'] ?? ''}</td>
								<td>{twoBack[QUES_CODE_PREFIX + '22-1a'] ?? ''}</td>
								<td>{twoBack[QUES_CODE_PREFIX + '22-1b'] ?? ''}</td>
								<td>{twoBack[QUES_CODE_PREFIX + '22-1c'] ?? ''}</td>
							</tr>
							<tr>
								<th>Permanent Workers </th>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '22-2a'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '22-2b'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '22-2c'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '22-2a'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '22-2b'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '22-2c'] ?? ''}</td>
								<td>{twoBack[QUES_CODE_PREFIX + '22-2a'] ?? ''}</td>
								<td>{twoBack[QUES_CODE_PREFIX + '22-2b'] ?? ''}</td>
								<td>{twoBack[QUES_CODE_PREFIX + '22-2c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderA5Q23 = () => {
		return (
			<div className='brsr-list-item'>
				<b>23. (a) Names of holding / subsidiary / associate companies / joint ventures</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Name of the holding	/ subsidiary	/ associate companies	/ joint ventures (A)    </th>
								<th>Indicate whether holding/ Subsidiary/ Associate/ Joint Venture    </th>
								<th>% of shares held	by listed entity     </th>
								<th>Does the entity indicated at column A, participate in the Business	Responsibility initiatives of the listed entity? (Yes/No)  </th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswerWrapper(1, 23, ['', 'a', 'b', 'c', 'd'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderAQ24 = () => {
		const answer = {};
		page1[QUES_CODE_PREFIX + '24']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		return (
			<div className='brsr-list-item'>
				{renderQuestionAnswerType2(
					'(i) Whether CSR is applicable as per section 135 of Companies Act, 2013: (Yes/No)',
					answer[QUES_CODE_PREFIX + '24a'] ?? ''
				)}
				{renderQuestionAnswerType2(
					'(ii) Turnover (in Rs.)',
					answer[QUES_CODE_PREFIX + '24b'] ?? ''
				)}
				{renderQuestionAnswerType2(
					'(iii) Net worth (in Rs.)',
					answer[QUES_CODE_PREFIX + '24c'] ?? ''
				)}
			</div>
		);
	};

	const renderA6Q25Part1 = () => {
		const answer = {}, oneBack = {};
		page1[QUES_CODE_PREFIX + '25']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		if (page1PrevData['oneBack']) {
			page1PrevData['oneBack'][QUES_CODE_PREFIX + '25']?.keyValues?.forEach(val => {
				oneBack[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>25. Complaints/Grievances on any of the principles (Principles 1 to 9) under the National Guidelines on Responsible Business Conduct:</b>
				<div className="mt-2">
					<Table responsive bordered size="sm">
						<thead>
							<tr>
								<th rowSpan="2">Stakeholder group from whom complaint is received </th>
								<th rowSpan="2">Grievance Redressal Mechanism in	Place (Yes/No) (If	Yes, then provide web-link for grievance redress policy) </th>
								<th colSpan="3" className="text-center FY_class white-nowrap">FY {yearFilter} </th>
								<th colSpan="3" className="text-center white-nowrap">FY {yearFilter - 1} </th>
							</tr>
							<tr>
								<th className="text-center FY_class_sub ">Number of complaints filed during the year </th>
								<th className="text-center FY_class_sub ">Number of complaints pending resolution at close of the year </th>
								<th className="text-center FY_class_sub ">Remarks  </th>
								<th className="text-center">Number of complaints filed during the year </th>
								<th className="text-center">Number of complaints pending resolution at close of the year </th>
								<th className="text-center">Remarks  </th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td> Communities  </td>
								<td className='text-break'>{answer[QUES_CODE_PREFIX + '25-1a'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-1b'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-1c'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-1d'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '25-1b'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '25-1c'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '25-1d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Investors (other	than shareholders) </td>
								<td>{answer[QUES_CODE_PREFIX + '25-2a'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-2b'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-2c'] ?? ''}</td>
								<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-2d'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '25-2b'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '25-2c'] ?? ''}</td>
								<td>{oneBack[QUES_CODE_PREFIX + '25-2d'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderA6Q25Part2 = () => {
		const answer = {}, oneBack = {};
		page1[QUES_CODE_PREFIX + '25']?.keyValues?.forEach(val => {
			answer[val.key] = formatBrsrNumericCellValue(val.value);
		});
		if (page1PrevData['oneBack']) {
			page1PrevData['oneBack'][QUES_CODE_PREFIX + '25']?.keyValues?.forEach(val => {
				oneBack[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<Table responsive bordered size="sm">
				<thead>
					<tr>
						<th rowSpan="2">Stakeholder group from whom complaint is received </th>
						<th rowSpan="2">Grievance Redressal Mechanism in	Place (Yes/No) (If	Yes, then provide web-link for grievance redress policy) </th>
						<th colSpan="3" className="text-center FY_class white-nowrap">FY {yearFilter} </th>
						<th colSpan="3" className="text-center white-nowrap">FY {yearFilter - 1} </th>
					</tr>
					<tr>
						<th className="text-center FY_class_sub">Number of complaints filed during the year </th>
						<th className="text-center FY_class_sub">Number of complaints pending resolution at close of the year </th>
						<th className="text-center FY_class_sub">Remarks  </th>
						<th className="text-center">Number of complaints filed during the year </th>
						<th className="text-center">Number of complaints pending resolution at close of the year </th>
						<th className="text-center">Remarks  </th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Shareholders </td>
						<td className='text-break'>{answer[QUES_CODE_PREFIX + '25-3a'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-3b'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-3c'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-3d'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-3b'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-3c'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-3d'] ?? ''}</td>
					</tr>
					<tr>
						<td>Employees and workers  </td>
						<td>{answer[QUES_CODE_PREFIX + '25-4a'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-4b'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-4c'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-4d'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-4b'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-4c'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-4d'] ?? ''}</td>
					</tr>
					<tr>
						<td>Customers  </td>
						<td>{answer[QUES_CODE_PREFIX + '25-5a'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-5b'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-5c'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-5d'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-5b'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-5c'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-5d'] ?? ''}</td>
					</tr>
					<tr>
						<td>Value Chain Partners   </td>
						<td>{answer[QUES_CODE_PREFIX + '25-6a'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-6b'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-6c'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-6d'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-6b'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-6c'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-6d'] ?? ''}</td>
					</tr>
					<tr>
						<td>Other (please specify)  </td>
						<td>{answer[QUES_CODE_PREFIX + '25-7a'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-7b'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-7c'] ?? ''}</td>
						<td className='FY_class_content'>{answer[QUES_CODE_PREFIX + '25-7d'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-7b'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-7c'] ?? ''}</td>
						<td>{oneBack[QUES_CODE_PREFIX + '25-7d'] ?? ''}</td>
					</tr>
				</tbody>
			</Table>
		);
	};

	const renderA7Q26 = () => {
		return (
			<div className='brsr-list-item'>
				<b>26. Overview of the entity's material responsible business conduct issues</b>
				<p className="mt-2">Please indicate material responsible business conduct and sustainability issues pertaining to environmental and social matters that present a risk or an opportunity to your business, rationale for identifying the same, approach to adapt or mitigate the risk along-with its financial implications, as per the following format</p>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th className='white-space'>S. No.</th>
								<th>Material	issue identified </th>
								<th>Indicate whether risk or opportunity (R/O)</th>
								<th>Rationale for identifying the	risk	/ opportunity </th>
								<th>In	case	 of risk, approach	 to adapt	or mitigate </th>
								<th>Financial implications of the risk or opportunity (Indicate positive or negative implications)</th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswerWrapper(1, 26, ['', 'a', 'b', 'c', 'd', 'e'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	return (
		<section id="Section_A" className="Main_Section Section_A">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head">
						<h5>SECTION A: GENERAL DISCLOSURES </h5>
					</div>
					<div className="ETA_card_Section_sub">
						{renderA1()}
						{renderA2()}
						{renderA3Q18()}
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 2">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderA3Q19()}
								</div>
							</div>
						</section>
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head">
								<b>IV. Employees   </b>
							</div>
							{renderA4Q20()}
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 3">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderA4Q21()}
									{renderA4Q22()}
								</div>
							</div>
						</section>
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head">
								<b>V. Holding, Subsidiary and Associate Companies (including joint ventures)   </b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderA5Q23()}
								</div>
							</div>
						</section>
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head">
								<b>VI. CSR Details</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderAQ24()}
								</div>
							</div>
						</section>
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head">
								<b>VII. Transparency and Disclosures Compliances </b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderA6Q25Part1()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 4">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									<div className='brsr-list-item'>
										<div className="mt-2">
											{renderA6Q25Part2()}
										</div>
									</div>
									{renderA7Q26()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRSectionA);
